
import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PaginationSection from "components/QuanTriHeThong/QuanLyLog/PaginationSection";
import DanhSachBanHangTable from "./DanhSachBanHangTable";
import React, { useEffect, useState } from "react";
import UserApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi";
import { pushNotification } from "utils/notifications";
import MenuChucNang from "./MenuChucNang";
import ModalThemSuaBanHang from "./ChucNang/ModalThemSuaBanHang";
import ModalXoaBanHang from "./ModalXoaBanHang";
import InPhieuBanHang from "../BanHang/ChucNang/InPhieuBanHang"
import InPhieuChenhLech from "../BanHang/ChucNang/InPhieuChenhLech"

const DanhSachBanHang = () => {
    const [listUserName, setListUserName] = useState([]);
    const [hasPermission, setHasPermission] = useState(null);
    const [RoleBanHangSua, setRoleBanHangSua] = useState(false);
    const [RoleBanHangXoa, setRoleBanHangXoa] = useState(false);
    const [RoleBanHangIn, setRoleBanHangIn] = useState(false);
    const [RoleBanHangThemMoi, setRoleBanHangThemMoi] = useState(false);
    const [ListData, setListData] = useState([]);
    const [Total, setTotal] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);
    const [TotalPaid, setTotalPaid] = useState(0);
    const [Loading, setLoading] = useState(true);
    const [showModalIn, setShowModalIn] = useState(false);
    const [showModalInChenhLech, setShowModalInChenhLech] = useState(false);
    const [showModalThemSua, setShowModalThemSua] = useState(false);
    const [printOrderId, setPrintOrderId] = useState(0);
    const [editingOrderId, setEditingOrderId] = useState(0);
    const [showModalXoa, setShowModalXoa] = useState(false);
    const [deletingOrderId, setDeletingOrderId] = useState(0);
    const fetchPermission = () => {
        setLoading(true);
        try {
            UserApi.getAllQuyen()
                .then((res) => {
                    const detailedRoles = res.data.map((item) => item.ModuleCode.toLowerCase());
                    const hasList = detailedRoles.includes("banhang") || detailedRoles.includes("banhang_danhsach");
                    setHasPermission(hasList);
                    if (hasList) {
                        setRoleBanHangSua(detailedRoles.includes("banhang_sua"));
                        setRoleBanHangXoa(detailedRoles.includes("banhang_xoa"));
                        setRoleBanHangIn(detailedRoles.includes("banhang_in"));
                        setRoleBanHangThemMoi(detailedRoles.includes("banhang_themmoi"));
                    }
                })
                .catch((err) => {
                    console.error("Lỗi load quyền chi tiết:", err);
                    setHasPermission(false);
                });
        } catch (err) {
            console.error("Lỗi fetchPermission:", err);
            setHasPermission(false);
        }
    };

    const loadDanhSachUserName = () => {
        UserApi.getAllUserName()
            .then((res) => {
                setListUserName(res.data || []);
            })
            .catch((error) => {
                console.error("Lỗi load danh sách user name:", error);
            });
    };

    const [dataSearch, setDataSearch] = useState({
        Type: 2, // Bán hàng = 2
        SearchText: "",
        UserName: "",
        TrangThai: 0,
        DateFrom: null,
        DateTo: null,
        pageIndex: 1,
        pageSize: 20
    });

    const LoadDanhSachBanHang = (searchData, page) => {
        setLoading(true);
        const payload = {
            ...searchData,
            DateFrom: searchData.DateFrom
                ? formatDayMonth(searchData.DateFrom)
                : undefined,
            DateTo: searchData.DateTo
                ? formatDayMonth(searchData.DateTo)
                : undefined,
            pageIndex: page
        };

        BanHangApi.getData(payload)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data || {};
                    setListData(data.List || []);
                    setTotal(data.TotalRecords || 0);
                    setTotalAmount(data.TotalAmountSum || 0);
                    setTotalPaid(data.TotalPaidOut || 0);
                    setDataSearch((prev) => ({ ...prev, pageIndex: page }));
                } else {
                    console.error("Lỗi khi load danh sách bán hàng: ", res.message);
                    pushNotification("Load danh sách bán hàng thất bại!", "error", "TOP_CENTER", 2000);
                }
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
            .catch((error) => {
                console.error("Lỗi khi gọi Api danh sách bán hàng:", error);
                pushNotification("Có lỗi khi gọi Api danh sách bán hàng!", "error", "TOP_CENTER", 2000);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        document.title = "Bán hàng | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
        loadDanhSachUserName();
    }, []);
    useEffect(() => {
        if (hasPermission) {
            LoadDanhSachBanHang(dataSearch, 1);
        }
    }, [hasPermission]);


    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const onChangeDate = (field) => (value) => {
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handlePageChange = (pageNumber) => {
        LoadDanhSachBanHang(dataSearch, pageNumber);
    };

    const onSearch = () => {
        LoadDanhSachBanHang(dataSearch, 1);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            LoadDanhSachBanHang(dataSearch, 1);
        }
    };

    const btnInBanHangClick = (orderId) => {
        setPrintOrderId(orderId);
        setShowModalIn(true);
    };

    const btnInChenhLechClick = (orderId) => {
        setPrintOrderId(orderId);
        setShowModalInChenhLech(true);
    };

    const btnThemDonBanHangClick = () => {
        setEditingOrderId(0);
        setShowModalThemSua(true);
    };

    const btnSuaDonBanHangClick = (orderId) => {
        setEditingOrderId(orderId);
        setShowModalThemSua(true);
    };

    const btnXoaDonBanHangClick = (orderId) => {
        setDeletingOrderId(orderId);
        setShowModalXoa(true);
    };

    const onCloseThemSuaModal = (isSuccess) => {
        setShowModalThemSua(false);
        setEditingOrderId(0);
        if (isSuccess === true) {
            onSearch();
        }
    };

    const onCloseXoaModal = (isSuccess) => {
        setShowModalXoa(false);
        setDeletingOrderId(0);
        if (isSuccess === true) {
            onSearch();
        }
    };

    const onCloseInModal = () => {
        setPrintOrderId(0);
        setShowModalIn(false);
        setShowModalInChenhLech(false);
    };

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (
        <>
            <LayoutV2>
                <div id="form-repeater">
                    <div className="sticky-moman-bh">
                        <div className="col-12">
                            <div className="camdo-home">
                                <div className="breadcrumb-new">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 title-cd">
                                            <div className="media-home align-center-home">
                                                <div className="row header">
                                                    <h1 className="text-info-home" style={{ fontSize: 25 }}>
                                                        <img
                                                            src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                                                            alt="logo"
                                                            className="mr-1"
                                                        />
                                                        Quản lý mua bán - Bán hàng</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="card border-light mb-1 show-table-main card-v2"
                                >
                                    <div className="card-body card-body-v2">
                                        <SearchForm
                                            listUserName={listUserName}
                                            dataSearch={dataSearch}
                                            onChangeData={onChangeData}
                                            onChangeDate={onChangeDate}
                                            onSearch={onSearch}
                                            handleKeyDown={handleKeyDown}
                                        />
                                    </div>
                                </div>
                                {Loading && (<>
                                    <div className="loader loader-default is-active"></div>
                                </>)}
                                {!Loading && (<>
                                    <div
                                        className="card border-light mb-1 card-v2"
                                        style={{ marginTop: "0px" }}
                                    >
                                        <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                                            <MenuChucNang
                                                dataSearch={dataSearch}
                                                listUserName={listUserName}
                                                btnThemMoiClick={btnThemDonBanHangClick}
                                                RoleThemMoi={RoleBanHangThemMoi}
                                            />
                                            <DanhSachBanHangTable
                                                listUserName={listUserName}
                                                list={ListData}
                                                Total={Total}
                                                TotalAmount={TotalAmount}
                                                TotalPaid={TotalPaid}
                                                btnSuaBanHangClick={btnSuaDonBanHangClick}
                                                btnXoaBanHangClick={btnXoaDonBanHangClick}
                                                btnInChenhLechClick={btnInChenhLechClick}
                                                btnInBanHangClick={btnInBanHangClick}
                                                RoleSua={RoleBanHangSua}
                                                RoleXoa={RoleBanHangXoa}
                                                RoleIn={RoleBanHangIn}
                                            />
                                        </div>
                                        <div
                                            className="card border-light mb-1 card-v2"
                                            style={{
                                                marginLeft: "15px",
                                                marginRight: "15px",
                                                marginTop: "15px",
                                            }}
                                        >
                                            <div
                                                className="card-body card-body-v2"
                                                style={{ display: Total === 0 ? "none" : "block" }}
                                            >
                                                <PaginationSection
                                                    iTotal={Total}
                                                    dataSearch={dataSearch}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutV2>
            {showModalThemSua && (
                <ModalThemSuaBanHang
                    orderId={editingOrderId}
                    onClose={onCloseThemSuaModal}
                />
            )}

            {showModalXoa && (
                <ModalXoaBanHang
                    orderId={deletingOrderId}
                    show={showModalXoa}
                    onHide={() => onCloseXoaModal(false)}
                    onSaved={() => onCloseXoaModal(true)}
                />
            )}
            {showModalIn && (
                <InPhieuBanHang
                    show={showModalIn}
                    onHide={onCloseInModal}
                    orderId={printOrderId}
                />
            )}
            {showModalInChenhLech && (
                <InPhieuChenhLech
                    show={showModalInChenhLech}
                    onHide={onCloseInModal}
                    orderId={printOrderId}
                />
            )}
        </>
    )

}
export default DanhSachBanHang;